import { Box, Typography } from "@mui/material";
import GroupOutlinedIcon from "@mui/icons-material/GroupOutlined";
import { parseTargetUserCount } from "../../utils/inAppNotificationUtils";
import { useDesignTokens } from "../../theme/useDesignTokens";

const NotificationTargetUserSummary = ({
  targetUserCount,
  label = "Targeted Users:",
}) => {
  const { colors, font } = useDesignTokens();
  const count = parseTargetUserCount(targetUserCount) ?? 0;

  return (
    <Box
      sx={{
        mb: { xs: 1.25, md: 1.5 },
        px: { xs: 1.25, sm: 1.5 },
        py: { xs: 1, sm: 1.25 },
        borderRadius: 1.5,
        border: `1px solid ${colors?.ghost?.light || "#E0E0E0"}`,
        bgcolor: colors?.primary?.lightest || "rgba(237, 108, 2, 0.04)",
        display: "flex",
        alignItems: "center",
        gap: 1,
        flexWrap: "wrap",
      }}
    >
      <GroupOutlinedIcon
        fontSize="small"
        sx={{ color: colors?.primary?.main || "primary.main" }}
      />
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ fontWeight: font?.weight?.fontW600 || 600 }}
      >
        {label}
      </Typography>
      <Typography
        variant="subtitle1"
        component="span"
        sx={{ fontWeight: font?.weight?.fontW700 || 700, lineHeight: 1.2 }}
      >
        {count}
      </Typography>
    </Box>
  );
};

export default NotificationTargetUserSummary;
